
import React from 'react';
import { Badge } from '@/components/ui/badge';

interface PaybackStatusBadgeProps {
  revenue: number;
  targetRevenue?: number;
}

const PaybackStatusBadge: React.FC<PaybackStatusBadgeProps> = ({ 
  revenue, 
  targetRevenue = 55000 
}) => {
  const percentage = (revenue / targetRevenue) * 100;
  
  const getStatusInfo = (percent: number) => {
    if (percent < 20) {
      return { 
        label: 'Критически низко', 
        variant: 'destructive' as const,
        className: 'bg-red-600 hover:bg-red-700 text-white font-semibold shadow-md'
      };
    }
    if (percent < 50) {
      return { 
        label: 'Требует внимания', 
        variant: 'warning' as const,
        className: 'bg-orange-500 hover:bg-orange-600 text-white font-semibold shadow-md'
      };
    }
    if (percent < 80) {
      return { 
        label: 'На пути к цели', 
        variant: 'warning' as const,
        className: 'bg-yellow-500 hover:bg-yellow-600 text-white font-semibold shadow-md'
      };
    }
    if (percent < 100) {
      return { 
        label: 'Почти окупился', 
        variant: 'success' as const,
        className: 'bg-green-500 hover:bg-green-600 text-white font-semibold shadow-md'
      };
    }
    return { 
      label: 'Полностью окупился', 
      variant: 'success' as const,
      className: 'bg-emerald-600 hover:bg-emerald-700 text-white font-semibold shadow-md'
    };
  };

  const statusInfo = getStatusInfo(percentage);

  return (
    <Badge 
      variant={statusInfo.variant}
      className={statusInfo.className}
    >
      {statusInfo.label}
    </Badge>
  );
};

export default PaybackStatusBadge;
